module.exports = __webpack_public_path__ + "static/media/exhibition.6927fe73.jpg";